// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.text-block-module__item___l_jF4:not(:last-of-type) {
  margin-bottom: 30px;
}
.text-block-module__item___l_jF4 a {
  text-decoration: underline;
  color: var(--primary600, #4b286d);
}
.text-block-module__item___l_jF4 a:hover {
  color: var(--primary700, #371e47);
}

.text-block-module__title___XlsGQ {
  font-size: 1.25rem;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/perks/components/text-block.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACGE;EACE,mBAAA;AAKJ;AAFE;EACE,0BAAA;EACA,iCAAA;AAIJ;AAHI;EACE,iCAAA;AAKN;;AAAA;EACE,kBAAA;EACA,mBAAA;AAGF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `text-block-module__item___l_jF4`,
	"title": `text-block-module__title___XlsGQ`
};
export default ___CSS_LOADER_EXPORT___;
